module.exports = __webpack_public_path__ + "static/media/este.d95af468.jpg";